// frontend/src/pages/builder/MatrixWells.jsx
// Phase 3 step 7e-3 (decision D12): the Matrix visual's slots, as in Power
// BI -- Rows (a hierarchy, up to 5), Columns (spread across the top, up to
// 2), Values (up to 10) -- and the Totals switch. The slots and chips are the
// chart's own (Wells.jsx): drop a field from the list, drag a chip between
// slots, pick a value's aggregation or a date's grain on its chip. Dropping
// a chip on the slot it is already in moves it to the end, which is how the
// hierarchy is reordered. Rules live in matrixSlots.js.
import React from 'react';
import { PanelHint, PanelLabel } from '@/components/ui/panel.jsx';
import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group.jsx';
import { MAX_COLUMN_FIELDS, MAX_ROW_FIELDS, matrixWells } from './matrixSlots';
import { Well } from './Wells';

export default function MatrixWells({
  draft, mx, fieldsByKey, onRemove, onDrop, onMoveChip, onAggregation, onGrain, onTotals,
}) {
  const w = matrixWells(draft, mx, fieldsByKey);
  const handlers = { onRemove, onDrop, onMoveChip, onAggregation, onGrain };
  const totals = !(mx && mx.totals === false);
  return (
    <div className="flex flex-col">
      <Well id="rows" label={`Rows · up to ${MAX_ROW_FIELDS}, outer to inner`} chips={w.rows}
        placeholder="Drop or click a field" fieldsByKey={fieldsByKey} handlers={handlers} />
      <Well id="columns" label={`Columns · up to ${MAX_COLUMN_FIELDS}`} chips={w.columns}
        placeholder="Optional · spreads a field across the top" fieldsByKey={fieldsByKey} handlers={handlers} />
      <Well id="values" label="Values" chips={w.values} placeholder="Count of records" fieldsByKey={fieldsByKey} handlers={handlers} />
      <PanelHint>Drop a chip on its own slot to move it to the end.</PanelHint>

      <PanelLabel id="builder-totals-label">Totals</PanelLabel>
      <ToggleGroup type="single" aria-labelledby="builder-totals-label" value={totals ? 'on' : 'off'}
        onValueChange={(v) => v && onTotals(v === 'on')}>
        <ToggleGroupItem value="off">Off</ToggleGroupItem>
        <ToggleGroupItem value="on">On</ToggleGroupItem>
      </ToggleGroup>
      <PanelHint>
        {totals ? 'A subtotal for every group and a grand total, worked out by the database, so averages and distinct counts are right.'
          : 'Only the cells, no subtotals or grand total.'}
      </PanelHint>
    </div>
  );
}